const CDN_KEY = 'cdn';

export const cdnKeys = {
  all: (schoolyearId: string, schoolId: string) =>
    [schoolyearId, schoolId, CDN_KEY] as const,
  cdnDetail: (schoolyearId: string, schoolId: string, id: string) =>
    [...cdnKeys.all(schoolyearId, schoolId), id] as const,
  cdnEvaluations: (
    schoolyearId: string,
    schoolId: string,
    id: string,
    opt?: string,
  ) =>
    [
      ...cdnKeys.cdnDetail(schoolyearId, schoolId, id),
      'evaluations',
      opt,
    ] as const,
  cdnEvaluationsOmittedInLivret: (
    schoolyearId: string,
    schoolId: string,
    id: string,
    opt?: string,
  ) =>
    [
      ...cdnKeys.cdnEvaluations(schoolyearId, schoolId, id),
      'omitted-in-livret',
      opt,
    ] as const,
  cdnEvaluationDetails: (
    schoolyearId: string,
    schoolId: string,
    cdnId: string,
    evaluationId,
  ) =>
    [
      ...cdnKeys.cdnEvaluations(schoolyearId, schoolId, cdnId),
      evaluationId,
    ] as const,
  cdnLimit: (schoolyearId: string, schoolId: string, id: string) =>
    [...cdnKeys.cdnDetail(schoolyearId, schoolId, id), 'limit'] as const,
  cdnList: (schoolyearId: string, schoolId: string) => [
    ...cdnKeys.all(schoolyearId, schoolId),
    'list',
  ],
  print: 'PRINT_LIVRET',
};
